import { format } from 'date-fns';

const nowToString = () =>  format(new Date(), 'yyyy-MM-dd');

export default nowToString;
